export const CREATE_WAITING_ROOM_OVERLAYER = 'CREATE_WAITING_ROOM_OVERLAYER';

export default CREATE_WAITING_ROOM_OVERLAYER;
